// components/EventRegistrationForm/RegistrationSteps.js
import React from 'react';
import { Lock, Smartphone, AtSign, User, Check } from 'lucide-react';

const RegistrationSteps = ({ formData }) => {
    return (
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 border border-blue-200 mb-6">
            <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                <Lock className="w-5 h-5 mr-2 text-blue-600" />
                Verification Steps
            </h3>
            <div className="flex items-center justify-center space-x-8">
                {/* Step 1: Phone Verification */}
                <div className={`flex flex-col items-center ${formData.verificationStep === 'phone' ? 'text-blue-600' : formData.phoneVerified ? 'text-green-600' : 'text-gray-400'}`}>
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-2 ${formData.verificationStep === 'phone' ? 'bg-blue-100 border-2 border-blue-500' : formData.phoneVerified ? 'bg-green-100 border-2 border-green-500' : 'bg-gray-100 border-2 border-gray-300'}`}>
                        {formData.phoneVerified ? (
                            <Check className="w-6 h-6" />
                        ) : (
                            <Smartphone className="w-5 h-5" />
                        )}
                    </div>
                    <span className="text-sm font-medium">Phone</span>
                    <span className="text-xs mt-1">
                        {formData.phoneVerified ? 'Verified' : formData.isExistingUser ? 'Auto-verified' : 'Verify'}
                    </span>
                </div>

                {/* Arrow */}
                <div className={`w-12 h-0.5 ${formData.phoneVerified || formData.isExistingUser ? 'bg-green-500' : 'bg-gray-300'}`}></div>

                {/* Step 2: Email Verification */}
                <div className={`flex flex-col items-center ${formData.verificationStep === 'email' ? 'text-blue-600' : formData.emailVerified ? 'text-green-600' : 'text-gray-400'}`}>
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-2 ${formData.verificationStep === 'email' ? 'bg-blue-100 border-2 border-blue-500' : formData.emailVerified ? 'bg-green-100 border-2 border-green-500' : 'bg-gray-100 border-2 border-gray-300'}`}>
                        {formData.emailVerified ? (
                            <Check className="w-6 h-6" />
                        ) : (
                            <AtSign className="w-5 h-5" />
                        )}
                    </div>
                    <span className="text-sm font-medium">Email</span>
                    <span className="text-xs mt-1">
                        {formData.emailVerified ? 'Verified' : formData.isExistingUser ? 'Auto-verified' : 'Verify'}
                    </span>
                </div>

                {/* Arrow */}
                <div className={`w-12 h-0.5 ${formData.emailVerified || formData.isExistingUser ? 'bg-green-500' : 'bg-gray-300'}`}></div>

                {/* Step 3: Details */}
                <div className={`flex flex-col items-center ${formData.verificationStep === 'details' ? 'text-blue-600' : 'text-gray-400'}`}>
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center mb-2 ${formData.verificationStep === 'details' ? 'bg-blue-100 border-2 border-blue-500' : 'bg-gray-100 border-2 border-gray-300'}`}>
                        <User className="w-5 h-5" />
                    </div>
                    <span className="text-sm font-medium">Details</span>
                    <span className="text-xs mt-1">Fill Details</span>
                </div>
            </div>
        </div>
    );
};

export default RegistrationSteps;